<template>
  <div class="host-view">
    <div class="mod-login" v-if="!loggedIn">
      <div class="mod-login__panel">
        <IdentityInput v-model="creds" :isMod="true" @submit="handleModLogin" />
      </div>
    </div>
    <div class="host-chat-panel" v-else>
      <Chat theme="admin" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"

import "@/components/Chat/themeAdmin.scss"
import Chat from "@/components/Chat/Chat.vue"
import IdentityInput from "@/components/IdentityInput"

export default {
  data: () => ({
    creds: {
      name: "",
      password: ""
    }
  }),

  components: {
    Chat,
    IdentityInput
  },

  mounted() {
    let partyId = this.$route.query.party_id
    this.$store.dispatch("chatStore/init", partyId)
  },

  methods: {
    handleModLogin() {
      if (this.creds.password == "bleachhostonly") {
        this.$store.dispatch("identityStore/login", [
          this.creds.name,
          this.creds.password
        ])
      }
    }
  },

  computed: {
    ...mapState({
      loggedIn: state => state.identityStore.loggedIn
    })
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";

.host-view {
  background: $bleach-pink;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.host-chat-panel {
  height: 100%;
}
</style>
